import { render, staticRenderFns } from "./FilterOptionItem.vue?vue&type=template&id=0ab15c78"
import script from "./FilterOptionItem.vue?vue&type=script&lang=js"
export * from "./FilterOptionItem.vue?vue&type=script&lang=js"
import style0 from "./FilterOptionItem.vue?vue&type=style&index=0&id=0ab15c78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports